export default __webpack_public_path__ + "static/media/test-grey.f22e9462.svg";